export default __webpack_public_path__ + "static/media/filter_flag_light.124eb870.svg";